/**
 * Gets next string in alphabetical order which comes after current string.
 * Ex. `nextString('curious') // Output 'curiout'`
 *
 * @param {String} str - any string
 *
 * @returns {String} - next string
 */
export function nextString(str) {
  const li = str.length - 1;
  return str.substring(0, li) + String.fromCharCode(str.charCodeAt(li) + 1);
}

/**
 * calculated and returns `slug`ged version of a text.
 *
 * @param {String} text - text to be slugged
 *
 * @returns {String} - slugged text
 */
export function getSlugged(text) {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w-]+/g, '') // Remove all non-word chars
    .replace(/--+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, ''); // Trim - from end of text
}

/**
 * Copies the given string to clipboard!
 *
 * @param {String} str - string to be copied.
 */

export const copyToClipboard = str => {
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};
